import { render, staticRenderFns } from "./CRMLoyaltyRewardCreateEditModal.vue?vue&type=template&id=7a8288d6"
import script from "./CRMLoyaltyRewardCreateEditModal.vue?vue&type=script&lang=js"
export * from "./CRMLoyaltyRewardCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports